import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

import authIntialState from './auth/api/intial-state-auth';
import {
  validateSSOToken_API_CALL,
  validateSSOToken_API_CALL_extrareducer,
} from './auth/api/validate-sso-2.0';
import {
  Logout_API_CALL,
  Logout_API_CALL_extrareducer,
} from './auth/api/logout-api-call';

// DOCS: Sync Method calls
import { flushSSOStateReducer } from './auth/functions/flush-sso-state';
import { updateCustomerCredReducer } from './auth/functions/update-customer-cred';
import { updateSSOStateReducer } from './auth/functions/update-sso-state';
import { updateUserNameReducer } from './auth/functions/update-names';
import { updateCompleteProfileRouteReducer } from './auth/functions/update-complete-profile-route';
import { updateSSOTokenReducer } from './auth/functions/update-sso-token';
import { updateMarketingQueryParamsReducer } from './auth/functions/update-marketing-queryparams';
import { updateHyperVergeTokenReducer } from './auth/functions/update-hyperverge-token';
import { updateAuthSSOBasedJourneyReducer } from './auth/functions/update-auth-sso-based-journey';
import { updateHideDashboardOnSidenavReducer } from './auth/functions/update-hide-dashboard-on-sidenav';

export const authSlice = createSlice({
  name: 'auth',
  initialState: authIntialState,
  reducers: {
    ...updateCustomerCredReducer,
    ...flushSSOStateReducer,
    ...updateSSOStateReducer,
    ...updateUserNameReducer,
    ...updateSSOTokenReducer,
    ...updateCompleteProfileRouteReducer,
    ...updateMarketingQueryParamsReducer,
    ...updateHyperVergeTokenReducer,
    ...updateAuthSSOBasedJourneyReducer,
    ...updateHideDashboardOnSidenavReducer,
  },
  extraReducers: {
    ...validateSSOToken_API_CALL_extrareducer,
    ...Logout_API_CALL_extrareducer,
  },
});

const {
  updateCustomerCred,
  flushSSOState,
  updateSSOState,
  updateUserName,
  updateCompleteProfileRoute,
  updateSSOToken,
  updateMarketingQueryParams,
  updateHyperVergeToken,
  updateAuthSSOBasedJourney,
  updateHideDashboardOnSidenav,
} = authSlice.actions;

export function useAuthStore() {
  const validateSSOState = useSelector(
    (state) => state.auth.validateSSOTokenAPICall
  );
  const customerId = useSelector((state) => state.auth.customerId);
  const ssoCustomerId = useSelector((state) => state.auth.ssoCustomerId);
  const ssoAuthorization = useSelector((state) => state.auth.ssoAuthorization);
  const customerRefNum = useSelector((state) => state.auth.customerRefNum);
  const Authorization = useSelector((state) => state.auth.Authorization);
  const showReferralScreen = useSelector(
    (state) => state.auth.showReferralScreen
  );
  const firstName = useSelector((state) => state.auth.firstName);
  const lastName = useSelector((state) => state.auth.lastName);
  const completeProfileRoute = useSelector(
    (state) => state.auth.completeProfileRoute
  );
  const ssoToken = useSelector((state) => state.auth.ssoToken);
  const hypervergeToken = useSelector((state) => state.auth.hypervergeToken);
  const logoutState = useSelector((state) => state.auth.logoutAPICall);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  return {
    // TODO: State returns here
    validateSSOState,
    customerId,
    customerRefNum,
    Authorization,
    logoutState,
    ssoCustomerId,
    ssoAuthorization,
    showReferralScreen,
    firstName,
    lastName,
    completeProfileRoute,
    ssoToken,
    authState,
    hypervergeToken,

    // DOCS: Write sync methods here
    updateCustomerCred: (payload) => dispatch(updateCustomerCred(payload)),
    updateSSOState: (payload) => dispatch(updateSSOState(payload)),
    updateUserName: (payload) => dispatch(updateUserName(payload)),
    updateCompleteProfileRoute: (payload) =>
      dispatch(updateCompleteProfileRoute(payload)),
    updateSSOToken: (payload) => dispatch(updateSSOToken(payload)),
    updateMarketingQueryParams: (payload) =>
      dispatch(updateMarketingQueryParams(payload)),
    updateHyperVergeToken: (payload) =>
      dispatch(updateHyperVergeToken(payload)),
    updateAuthSSOBasedJourney: (payload) =>
      dispatch(updateAuthSSOBasedJourney(payload)),
    updateHideDashboardOnSidenav: (payload) =>
      dispatch(updateHideDashboardOnSidenav(payload)),

    // TODO: Write the async action functions here
    validateSSOAPICall: (payload) =>
      dispatch(validateSSOToken_API_CALL(payload)),
    flushSSOState: (payload) => dispatch(flushSSOState(payload)),
    logoutAPICall: (payload) => dispatch(Logout_API_CALL(payload)),
  };
}

export default authSlice.reducer;
